import { readFileAsText } from "../../core/utils/file";
import type { GeoJsonDocument } from "../../core/types/geojson";
import { GeoJsonParser } from "./GeoJsonParser";

export class GeoJsonLoader {
  static async fromFile(file: File): Promise<GeoJsonDocument> {
    return GeoJsonParser.parse(await readFileAsText(file));
  }

  static async fromUrl(url: string): Promise<GeoJsonDocument> {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Could not load GeoJSON from ${url}: ${response.status}`);
    return GeoJsonParser.parse(await response.text());
  }
}
